import React from 'react'

const Header = ({ item }) => {
  return (
    <div className={`${item.className || ''}`}>
      <div className={`flex flex-col ${item.headerClassName || ''}`}>
        <div className=" text-gray-900 text-xl font-medium">{item.label}</div>
        {/*<div className=" text-gray-400 text-sm font-normal ">{item.hint}</div>*/}
      </div>
    </div>
  )
}

export default Header
